import * as React from 'react';
import { supabase } from '../components/supabaseClient.tsx';
import {JSX, useState} from "react";
import Button from '@mui/material/Button';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import { Collapse, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function Login() {
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState('')
    const [alert, setAlert] = useState<JSX.Element | null>(null);
    const [open, setOpen] = React.useState(true);


    React.useEffect(() => {
        // Add styles to prevent scrolling
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
        document.documentElement.style.height = '100%';
        document.body.style.height = '100%';

        // Cleanup styles on component unmount
        return () => {
            document.body.style.overflow = '';
            document.documentElement.style.overflow = '';
            document.documentElement.style.height = '';
            document.body.style.height = '';
        };
    }, []);

    const handleLogin = async (event: { preventDefault: () => void; }) => {
        event.preventDefault()

        setLoading(true)
        const { error } = await supabase.auth.signInWithOtp({ email, options: {emailRedirectTo: 'https://home-app-e9j.pages.dev/Dashboard'} })

        if (error) {
            setAlert(
                <Collapse in={open}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"error"}
                    >
                        <AlertTitle>Error</AlertTitle>
                        Something went wrong!
                    </Alert>
                </Collapse>
            );
        } else {
            setAlert(
                <Collapse in={open}>
                    <Alert
                        action={
                            <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                    setOpen(false);
                                    setAlert(null);
                                }}
                            >
                                <CloseIcon fontSize="inherit" />
                            </IconButton>
                        }
                        sx={{ mb: 2 }}
                        severity={"success"}
                    >
                        <AlertTitle>Success</AlertTitle>
                        Check your email for the login link!
                    </Alert>
                </Collapse>
            );

        }
        setLoading(false)
    }

    return (
        <div style={{
            width: '1152px',
            height: '824px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            backgroundImage: 'url("/Pictures/Login.png")',
            backgroundSize: '70%',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center -20%'
        }}>
            <div style={{
                position: 'absolute',
                top: '20px',
                right: '20px',
                zIndex: 1000,
            }}>
                {alert}
            </div>
            <div style={{
                width: '100%',
                maxWidth: '400px',
                paddingLeft: '20px',
                paddingRight: '30px',
                paddingTop: '300px',
            }}>
                <form className="form-widget" onSubmit={handleLogin}>
                    <div>
                        <TextField
                            className="inputField"
                            id="outlined-password-input"
                            label="Email"
                            type="email"
                            value={email}
                            required={true}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Your email"
                            style={{width: '100%', height: '50px'}} // Increase size
                        />
                    </div>
                    <div>
                        <Button variant="contained"
                                className={'button block'}
                                disabled={loading}
                                endIcon={<SendIcon/>}
                                onClick={handleLogin}
                                style={{width: '100%', height: '50px', marginTop: '20px'}} // Increase size>
                        >
                            {loading ? <span>Loading</span> : <span>Send magic link</span>}
                        </Button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default Login;